/*
 * @Author: 任晓帅
 * @Contact: VX:ren18321147631
 * @Date: 2026-03-08 13:23:34
 * @Description: 不可进行二次销售
 */
export default {
    // API基础路径
    // baseURL: 'https://shortvideo.api.yszcwy.com/',
    // uploadUrl: 'https://shortvideo.api.yszcwy.com/shop/index/upload', // 文件上传URL
    // 请求超时时间
    baseURL: 'https://video.91nongjia.com/',
    uploadUrl: 'https://video.91nongjia.com/shop/index/upload', // 文件上传URL
}